import React from "react";
import { Switch, Route } from "react-router-dom";
import { Home } from "../views/home/Home";

import Supplier from "../views/supplier/view"
import SupplierDetails from "../views/supplier/view/details"

import InquiryList from "../views/inquiry/view"
import InquiryDetails from "../views/inquiry/view/details"
import InquiryContrast from "../views/inquiry/view/contrast"

import InquiryResultList from "../views/inquiryResult/view/index"
import InquiryResulDetail from "../views/inquiryResult/view/details"




function ScmRoute() {
    return (
        <Switch>
            <Route exact={true} path={"/"} key="1" component={Home} />

            <Route exact={true} path={"/supplier"} key="2" component={Supplier} />
            <Route exact={true} path={"/supplier/add"} key="2-1" component={SupplierDetails} />
            <Route exact={true} path={"/supplier/edit"} key="2-2" component={SupplierDetails} />


            <Route exact={true} path={"/inquiry/list"} key="3" component={InquiryList} />
            <Route exact={true} path={"/inquiry/add"} key="3-1" component={InquiryDetails} />
            <Route exact={true} path={"/inquiry/edit"} key="3-2" component={InquiryDetails} />
            <Route exact={true} path={"/inquiry/contrast"} key="3-3" component={InquiryContrast} />
            
            <Route exact={true} path={"/inquiryResult/list"} key="4" component={InquiryResultList} />
            <Route exact={true} path={"/inquiryResult/detail"} key="4-1" component={InquiryResulDetail} />

        </Switch>
    )
}

export default ScmRoute;
